<template>
    <div id="dedupsearchform">
        <v-container id="dedupsearchform__container">
            <v-row no-gutters id="dedupsearchform__searchbox" class="pa-0 ma-0">
                <v-col :cols="6">
                    <v-text-field
                        label="Search"
                        ref="input_query"
                        outlined
                        dense
                        clearable
                        prepend-inner-icon="mdi-search-web"
                        v-model="searchQuery"
                    />
                </v-col>
                <div id="dedupsearchform__button--2" >
                    <v-btn color="indigo white--text" @click.prevent="search" depressed ref="btn1">Search</v-btn>
                </div>
                <div id="dedupsearchform__button--3">
                    <v-btn color="indigo white--text" @click.prevent="clearSearch" depressed ref="btn2">Clear</v-btn>
                </div>
            </v-row>
            <v-row no-gutters>
                <v-col :cols="6">
                    <v-row align="center" no-gutters>
                        <v-col cols="2" no-gutters>
                            <v-checkbox label="ID" ref="fontsize2" v-model="sesrchById"/>
                        </v-col>
                        <v-col cols="2">
                            <v-checkbox label="Subject" ref="fontsize3" v-model="searchBySubject"/>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: "dedupsearchform",
    data: () => ({}),
    mounted: function() {
        let nodes = document.querySelectorAll(".v-messages"),
            size = nodes.length,
            i
        for (i = 0; i < size; i++) {
            nodes[i].style.display = 'none'
        }
        nodes = document.querySelectorAll(".v-text-field__details"), size = nodes.length
        for (i = 0; i < size; i++) {
            nodes[i].style.display = 'none'
        }
    },
    computed: {
        searchQuery: {
            get:function() {
                return this.$store.getters['Deduplicate/getSearchQuery']
            },
            set: function(o) {
                this.$store.dispatch('Deduplicate/setSearchQuery', o)
            }
        },
        sesrchById: {
            get:function() {
                return this.$store.getters['Deduplicate/getSearchById']
            },
            set: function(o) {
                this.$store.dispatch('Deduplicate/setSetSearchBySubject', false)
                this.$store.dispatch('Deduplicate/setSearchQuery', '')
                this.$store.dispatch('Deduplicate/setSearchById', o)
            }
        },
        searchBySubject: {
            get:function() {
                return this.$store.getters['Deduplicate/setSetSearchBySubject']
            },
            set: function(o) {
                this.$store.dispatch('Deduplicate/setSearchById', false)
                this.$store.dispatch('Deduplicate/setSearchQuery', '')
                this.$store.dispatch('Deduplicate/setSetSearchBySubject', o)
            }
        }
    },
    methods: {
        search: function() {
            this.$utils.searchDeduplication(this)
        },
        clearSearch: function() {
            var view = this
            view.$store.dispatch('Deduplicate/setIsFromSearch', false).then(function () {
                return view.$store.dispatch('Deduplicate/setSearchQuery', '')
            }).then(function() {
                return view.$store.dispatch('Deduplicate/setSearchById', false)
            }).then(function() {
                return view.$store.dispatch('Deduplicate/setSetSearchBySubject', false)
            }).then(function() {
                return view.$store.dispatch('Deduplicate/setPerPage', 10)
            }).then(function() {
                return view.$store.dispatch('Deduplicate/setPage', 1)
            }).then(function() {
                view.$utils.fetchDeduplicates(view)
            })
        }
    }
}
</script>
<style lang="sass" scoped>
@import './../assets/sass/dedupsearchform'
</style>
